module.exports = __webpack_public_path__ + "img/75735.d0096bd7.svg";